export default __webpack_public_path__ + "static/media/avatar3.6cb95d9c.jpg";